/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-alert */
import React, { useEffect, useState } from 'react';
import { useParams, Link, useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Row, Col, Card, CardBody, CardHeader, CardTitle, NavItem, NavLink,
  TabContent, TabPane, Nav, Collapse, Button, InputGroup,
} from 'reactstrap';
import classnames from 'classnames';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import { withTranslation } from 'react-i18next';
import moment from 'moment';

import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import ProfileSelector from '../../components/Profile/ProfileSelector';
import ItemForm from '../../components/Item/ItemForm';
import BaseGrid from '../../components/Common/BaseGrid';
import { get } from '../../helpers/api_helper';
import * as url from '../../helpers/url_helper';
import Stock from '../../components/Item/Stock';
import Substitutes from '../../components/Item/Substitutes';
import Statistics from '../../components/Item/Statistics';
import ListButton from '../../components/User/ListButton';
import Popularity from '../../components/Item/Popularity';
import UsageHistoryChart from '../../components/Item/UsageHistoryChart';
import ItemProperties from '../../components/Item/Properties';

function ViewItem(props) {
  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const history = useHistory();
  const { t } = props;
  const { id } = useParams();

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);
  const [activeTab, setActiveTab] = useState('1');
  const [isGallery, setIsGallery] = useState(false);
  const [imageIndex, setImageIndex] = useState(0);
  const [refresh, setRefresh] = useState(0);
  const [editCollapse, setEditCollapse] = useState(false);
  const [selectedNewListingProfile, setSelectedNewListingProfile] = useState(null);
  const [formBusy, setFormBusy] = useState(false);

  const toggle = (tab) => {
    setActiveTab(tab);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const item = await get(`${url.GET_ITEM}/${id}`);

        setData(item);
      } catch (e) {
        setError(e.message);
      } finally {
        setLoading(false);
      }
    };

    setLoading(true);
    fetchData();
  }, [refresh, id]);

  const onSuccess = () => {
    setRefresh(refresh + 1);
    setEditCollapse(false);
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Row>
          <Col xxl="7">
            <Collapse isOpen={editCollapse}>
              <Card>
                <CardBody>
                  <CardTitle className="h4">{t('Edit Item')}</CardTitle>
                  {data !== null && (
                    <ItemForm
                      actionUrl={url.POST_ITEM}
                      entity={data}
                      onSuccess={onSuccess}
                      onBusyChange={setFormBusy}
                    />
                  )}
                  <Button
                    type="submit"
                    color="primary"
                    form="ItemEditForm"
                    className="float-end"
                    disabled={formBusy}
                  >
                    {formBusy ? t('Adding models...') : t('Save Changes')}
                  </Button>
                  <Button
                    type="button"
                    color="dark"
                    onClick={() => { setEditCollapse(false); }}
                    className="float-end me-3 btn-soft-dark"
                  >
                    {t('Cancel')}
                  </Button>
                </CardBody>
              </Card>
            </Collapse>

            <Collapse isOpen={!editCollapse}>
              <Row>
                <Col xl="7">
                  <Card>
                    <CardHeader className="text-uppercase bg-transparent border-bottom">{t('Item Details')}</CardHeader>
                    <CardBody>
                      <table className="table table-bordered table-striped responsiveTable mt-3">
                        <tbody>
                          <tr>
                            <th>{t('Item ID')}</th>
                            <td>{loading === true ? t('Loading...') : data.id}</td>
                          </tr>
                          <tr>
                            <th>{t('Manufacturer')}</th>
                            <td>{loading === true ? t('Loading...') : data.manufacturer}</td>
                          </tr>
                          <tr>
                            <th>{t('Part Number')}</th>
                            <td>{loading === true ? t('Loading...') : data.part_number}</td>
                          </tr>
                          <tr>
                            <th>{t('Condition')}</th>
                            <td>{loading === true ? t('Loading...') : data.condition}</td>
                          </tr>
                        </tbody>
                      </table>

                      <div className="hstack gap-2 mt-3">
                        <Button color="primary" title={t('Edit Item')} onClick={() => { setEditCollapse(true); }}>
                          <span className="mdi mdi-pencil" />
                        </Button>
                        <Button color="primary" className="btn-soft-primary" title={t('Create Similar')} onClick={() => { history.push(`/items/create/${data.id}`); }}>
                          <span className="mdi mdi-content-duplicate" />
                        </Button>

                        {data !== null && (
                          <>
                            <Link title={t('Reprint Shelf Label')} className="btn btn-primary btn-soft-primary" to={`/sourcing/reprint/${data.id}`}>
                              <span className="mdi mdi-printer" />
                            </Link>
                            <ListButton item={data} />
                          </>
                        )}
                      </div>
                    </CardBody>
                  </Card>
                </Col>

                <Col xl="5">
                  {data !== null && (
                    <Statistics item={data} />
                  )}

                  {data && (
                    <Popularity item={data} />
                  )}

                </Col>
              </Row>

              <Row>
                <Col xl="7">
                  <Card>
                    <CardHeader className="text-uppercase bg-transparent border-bottom">{t('Board Numbers')}</CardHeader>
                    <CardBody>
                      <table className="table table-bordered table-striped responsiveTable mt-3">
                        <tbody>
                          <tr>
                            <th>{t('Visible Numbers')}</th>
                            <td>
                              {loading === true || !data ? t('Loading...') : data.boardNumbers.map(
                                (x) => (x.label === 'Visible Number' ? x.value : ''),
                              ).filter((str) => str !== '').join(', ')}
                            </td>
                          </tr>
                          <tr>
                            <th>{t('Manufacturer Part Numbers')}</th>
                            <td>
                              {loading === true || !data ? t('Loading...') : data.boardNumbers.map(
                                (x) => (x.label === 'Manufacturer Part Number' ? x.value : ''),
                              ).filter((str) => str !== '').join(', ')}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </CardBody>
                  </Card>
                </Col>
              </Row>

            </Collapse>
          </Col>

          <Col xxl="5">
            <Card>
              <CardBody>
                {error !== null && (
                  <p className="text-danger">{error}</p>
                )}
                <div>
                  <div className="popup-gallery hstack gap-2">
                    {data !== null && data.images && data.images.length > 0
                      && data.images.map((x, i) => (
                        <div key={x.id} className="img-fluid">
                          <img
                            src={x.url}
                            alt={x.alt}
                            style={{
                              cursor: 'pointer', width: '100%', maxWidth: '500px', maxHeight: '200px',
                            }}
                            onClick={() => { setIsGallery(true); setImageIndex(i); }}
                          />
                        </div>
                      ))}
                  </div>
                </div>
              </CardBody>
            </Card>

            {data !== null && (
              <>
                <Stock entity={data} />

                <Card>
                  <CardHeader className="border-bottom bg-transparent text-uppercase">{t('Substitutes')}</CardHeader>
                  <CardBody>
                    <Substitutes item={data} />
                  </CardBody>
                </Card>
              </>
            )}
          </Col>
        </Row>

        <Row>
          <Col lg="12">
            {data !== null && (
              <UsageHistoryChart item={data} />
            )}
          </Col>
        </Row>

        <Row>
          <Col lg="12">
            <Nav tabs>
              <NavItem>
                <NavLink
                  style={{ cursor: 'pointer' }}
                  className={classnames({
                    active: (activeTab === '1'),
                  })}
                  onClick={() => {
                    toggle('1');
                  }}
                >
                  {t('Listings')}
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  style={{ cursor: 'pointer' }}
                  className={classnames({
                    active: (activeTab === '5'),
                  })}
                  onClick={() => {
                    toggle('5');
                  }}
                >
                  {t('ISU')}
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  style={{ cursor: 'pointer' }}
                  className={classnames({
                    active: (activeTab === '6'),
                  })}
                  onClick={() => {
                    toggle('6');
                  }}
                >
                  {t('Sourcing')}
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  style={{ cursor: 'pointer' }}
                  className={classnames({
                    active: (activeTab === '7'),
                  })}
                  onClick={() => {
                    toggle('7');
                  }}
                >
                  {t('Properties')}
                </NavLink>
              </NavItem>
            </Nav>

            <TabContent
              activeTab={activeTab}
            >
              <TabPane tabId="1">
                <Card className="border border-light border-top-0" style={{ borderRadius: '0px' }}>
                  <CardBody>
                    <Row>
                      <Col xl="4">
                        <InputGroup>
                          {selectedNewListingProfile !== null && (
                            <>
                              <Button color="light" onClick={() => { setSelectedNewListingProfile(null); }}>
                                {t('Create New')}
                                {' '}
                                {selectedNewListingProfile.name}
                              </Button>
                              <Link to={`/listings/create/${id}/${selectedNewListingProfile.id}`} className="btn btn-secondary">
                                <span className="mdi mdi-arrow-right" />
                              </Link>
                            </>
                          )}
                          {selectedNewListingProfile === null && (
                            <>
                              <ProfileSelector
                                onSelect={(x) => { setSelectedNewListingProfile(x); }}
                              />
                              <Button disabled color="primary">{t('New')}</Button>
                            </>
                          )}
                        </InputGroup>
                      </Col>
                    </Row>
                    <BaseGrid
                      url={url.GET_LISTINGS}
                      hasSearch={false}
                      shouldPaginate={false}
                      shouldUpdate={refresh}
                      filters={`items_join.item_id=${id}`}
                      config={
                        {
                          columns: {
                            thumb: {
                              label: '',
                              image: {
                                src: (item) => (`/api/listings/thumbnail/${item.id}`),
                                class: 'rounded',
                                style: { maxHeight: '5rem', maxWidth: '5rem' },
                              },
                              translate: false,
                            },
                            id: {
                              label: 'ID',
                              sort: true,
                              link: {
                                to: '/listing/%id%',
                              },
                            },
                            sku: { label: 'Sku', sort: true },
                            title: { label: 'Title', sort: true },
                            price: {
                              label: 'Price',
                              sort: false,
                              format: (x) => new Intl.NumberFormat(
                                'en-US',
                                {
                                  style: 'currency',
                                  currency: 'USD',
                                },
                              ).format(x),
                            },
                            created_at: {
                              label: props.t('Created'),
                              date: {
                                format: (date) => (moment(date).fromNow()),
                                timezone: process.env.LOCAL_TZ,
                              },
                              sort: true,
                            },
                          },
                          pagination: {
                            sort: 'id',
                            direction: 'desc',
                            perPage: 30,
                          },
                        }
                      }
                    />
                  </CardBody>
                </Card>
              </TabPane>

              <TabPane tabId="5">
                <Card className="border border-light border-top-0" style={{ borderRadius: '0px' }}>
                  <CardBody>
                    <BaseGrid
                      url="/api/items/usages"
                      hasSearch={false}
                      shouldPaginate
                      shouldUpdate={refresh}
                      filters={`item_id=${id}`}
                      config={
                        {
                          columns: {
                            thirty_rate: {
                              label: 'ISU',
                              html: true,
                              format: (f) => (
                                `<strong>${f ? f.toFixed(1) : '--'}</strong>`
                              ),
                            },
                            used_qty: { label: 'Used Qty' },
                            in_stock_for: {
                              label: props.t('In-stock for'),
                              format: (f, x) => {
                                // Example dates
                                const start = moment(x.in_at);
                                const end = moment(x.out_at || new Date(Date.now()));

                                // Get the difference in milliseconds
                                const duration = moment.duration(end.diff(start));

                                // Output the largest whole unit (e.g., days)
                                const days = duration.asDays(); // gets days as a float
                                const roundedDays = Math.floor(days);

                                return `${roundedDays} ${roundedDays === 1 ? 'day' : 'days'}`;
                              },
                            },
                            in_at: {
                              label: props.t('In-stock'),
                              date: {
                                format: (date) => (moment(date).format('ddd, MMM D YYYY HH:mm')),
                                timezone: process.env.LOCAL_TZ,
                              },
                            },
                            out_at: {
                              label: props.t('Out of stock'),
                              date: {
                                format: (date) => (moment(date).format('ddd, MMM D YYYY HH:mm')),
                                timezone: process.env.LOCAL_TZ,
                              },
                            },
                          },
                          pagination: {
                            sort: 'id',
                            direction: 'desc',
                            perPage: 30,
                          },
                        }
                      }
                    />
                  </CardBody>
                </Card>
              </TabPane>

              <TabPane tabId="6">
                <Card className="border border-light border-top-0" style={{ borderRadius: '0px' }}>
                  <CardBody>
                    <BaseGrid
                      url={`/api/sourcing/item/${id}`}
                      hasSearch={false}
                      shouldPaginate
                      shouldUpdate={refresh}
                      config={
                        {
                          columns: {
                            id: {
                              label: 'Order ID',
                              link: {
                                to: '/sourcing/order/%id%',
                              },
                            },
                            lot: {
                              label: 'Lot',
                              link: {
                                to: '/sourcing/order/%id%',
                              },
                            },
                            qty_inducted: {
                              label: 'Inducted',
                            },
                            qty_shipped: {
                              label: 'Shipped',
                            },
                            supplier: {
                              label: 'Supplier',
                              format: (f) => (f.name),
                            },
                            program: {
                              label: 'Program',
                              format: (f) => (f.name),
                            },
                            created_at: {
                              label: props.t('Created'),
                              date: {
                                format: (date) => (moment(date).format('ddd, MMM D YYYY HH:mm')),
                                timezone: process.env.LOCAL_TZ,
                              },
                            },
                          },
                          pagination: {
                            sort: 'id',
                            direction: 'desc',
                            perPage: 30,
                          },
                        }
                      }
                    />
                  </CardBody>
                </Card>
              </TabPane>

              <TabPane tabId="7">
                <Card className="border border-light border-top-0" style={{ borderRadius: '0px' }}>
                  <CardBody>
                    {activeTab === '7' && (
                      <ItemProperties item={data} />
                    )}
                  </CardBody>
                </Card>
              </TabPane>
            </TabContent>
          </Col>
        </Row>
      </div>

      {isGallery ? (
        <Lightbox
          mainSrc={data.images[imageIndex].url}
          enableZoom={false}
          onCloseRequest={() => setIsGallery(false)}
          imageCaption={data.images[imageIndex].label}
        />
      ) : null}
    </div>
  );
}

ViewItem.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
};

export default connect(() => ({

}), {})(withTranslation()(ViewItem));
